import { CreatePDFFilial } from "./filial";
import { CreatePDFSucursal } from "./sucursal";

export const CreatePDF = (data,irpf,esAdm,isDownload,translate)=>{
    const _tipoEmpresa = data[0].informe.total.tipoEmpresa;
    const _subTipoEmpresa = data[0].informe.total.subTipoEmpresa;

    if(_tipoEmpresa === 'S' || _subTipoEmpresa === 'S'){
        CreatePDFSucursal(data,irpf,esAdm,isDownload,translate);
    }else{
        CreatePDFFilial(data,irpf,esAdm,isDownload,translate)
    }
}